import { render, staticRenderFns } from "./dormBuildDialog.vue?vue&type=template&id=2a7d47da&"
import script from "./dormBuildDialog.vue?vue&type=script&lang=js&"
export * from "./dormBuildDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports